
Happy Valentine's Day, people of the interwebs! ❤️

I'm officially attending SXSW 2020 in Austin, Texas! I jumped for the Platinum Badge which means I have all access to all events. If you happen to be reading this and know of anything please let me know!

# Georgia Tech alumni in Austin?

Let's sync up for a GT alumni event! I might be able to get some funds from the College of Computing for at least food somewhere as the newly minted GT Computing Alumni Network NYC representative.


